import styled from 'styled-components';

export const ContentWrapper = styled.div`
  background-color: white;
  padding: 16px;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.2);
`
export const Divider = styled.div`
  background-color: #E0E0E0;
  width: 100%;
  height: 1px;
  margin: 20px 0px
`;

export const PageHeader = styled.div`
  display: flex;
  margin-top: 0;
  margin-bottom: 16px;
  color: #4C4C4C;
  font-size: 14px;
  font-weight: bold;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
`

export const LoadingText = styled.p`
  color: #007aba;
  font-weight: bold;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
  margin-top: -35px;
`;

export const PageTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 27px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #007ABA;
  width: 100%;
  /* border-bottom: 2px solid #8e8e8e;*/
  padding-top: 20px;
  padding-bottom: 20px;
  @media screen and (max-width: 700px){
    flex-direction: column;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`
export const PageTitle1 = styled.div`
font-family: 'IBM Plex Sans';
font-style: normal;
font-weight: 500;
font-size: 32px;
line-height: 40px;
width: 284px;
height: 40px;
display: flex;
align-items: center;

color: #000000;
flex: none;
order: 0;
flex-grow: 0;
padding-top: 20px;
padding-bottom: 20px;
margin-top: 20px;
margin-bottom: 20px;
justify-content: space-between;
  @media screen and (max-width: 700px){
    flex-direction: column;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`

export const PageSecondTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 22px;
  marginBottom: 10px;
  color: #007ABA;
  width: 100%;
  /* border-bottom: 2px solid #8e8e8e;*/
  padding-top: 20px;
  padding-bottom: 20px;
  @media screen and (max-width: 700px){
    flex-direction: column;
    margin-bottom: 0px;
    margin-top: 0px;
  }
`

export const PageSubTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin-bottom: 20px;
  color: #007ABA;
  width: 100%;
  /* border-bottom: 2px solid #8e8e8e;*/
  /* padding-bottom: 20px; */
  @media screen and (max-width: 700px){
    flex-direction: column;
  }
`

export const SnackbarContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  min-width: 372px;
  padding: 0 28px;
  height: 40px;
  white-space: nowrap;
  color: white;
  font-family: Roboto;
  background-color: ${props => props.error ? '#ED1C24' : '#00B400'};
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.2);
`
export const TableWrapper = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const SVGContainer = styled.div`
display: flex;
align-items: center;
cursor:pointer;
margin-left: 10px;
 svg{
  font-size: 22px;
  color:#929AEA;
  &:hover{
    color:#5060fb;
  }
 }
`;

export const TTBody = styled.p`
color: #fff;
font-family: inherit;
font-weight: 400;
font-size: 12px;
text-align: left;
`;
